import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { ProfileConfirmModalComponent } from '../../../../dashboard/loggedin-content/profile/profile-confirm-modal/profile-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import {
  FormBase,
  FormBaseControlService,
  AlertService,
  ErrorMessageService,
  GTagService,
} from '@mapfre-design-library/src/public_api';
import { ProfileConfirmModalService } from '../../../../../_services/profile-settings/profile-confirm-modal.service';
import { ChangeProfileEmailService } from '../../../../../_services/profile-settings/change-profile-email.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { PaperlessService } from '../../../../../_services/_iam/paperless.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ProfileConfirmModalComponent, MapfreAlertComponent, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-edit-email-form',
  templateUrl: './edit-email-form.component.html',
})
export class EditEmailFormComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  @Input() userData: any;
  confirmModal: boolean;
  editEmailForm: FormGroup;
  newEmailObservable = '';
  currentEmail: string;
  previousURL: any;
  loader = false;
  constructor(
    private ipt: FormBaseControlService,
    private alertService: AlertService,
    private changeProfileEmailService: ChangeProfileEmailService,
    public router: Router,
    private profileConfirmModalService: ProfileConfirmModalService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private errorMessageService: ErrorMessageService,
    private paperlessService: PaperlessService,
    private errorRedirectionService: ErrorRedirectionService,
    private gTagService: GTagService,
    private translate: TranslateService
  ) {}

  checkIfEmailExists(): void {
    const newEmail = this.editEmailForm.controls.changeEmail.value,
      confirmEmail = this.editEmailForm.controls.confirmation_changeEmail.value;
    this.loader = true;
    if (newEmail.toLowerCase() === confirmEmail.toLowerCase()) {
      this.changeProfileEmailService
        .checkEmailExists(this.currentEmail, newEmail)
        .subscribe(
          () => {
            this.gTagService.triggerFormLink('editEmailForm', 'true', '');
            this.loader = false;
            this.changeProfileEmailService.saveEmail(newEmail);
            this.router.navigate(['/profile', 'email-confirmation']);
          },
          (error) => {
            this.gTagService.triggerFormLink(
              'editEmailForm',
              'false',
              this.translate.instant('UPDATE_EMAIL_ERROR')
            );
            this.loader = false;
            this.errorRedirectionService.errorHandler(error, 'EMAIL_IN_USE');
          }
        );
    } else {
      this.loader = false;
      this.errorMessageService.updateErrorMessage({
        message: 'EMAIL_MISMATCH',
        error: true,
        key: 'confirmation_changeEmail',
      });
      this.gTagService.triggerFormLink(
        'editEmailForm',
        'false',
        this.translate.instant('EMAIL_DOESNOT_MATCH')
      );
    }
  }

  editEmailValue(email): void {
    this.editEmailForm.patchValue({
      changeEmail: email,
    });
  }

  onCheckDirty(): void {
    this.profileConfirmModalService.onCheckDirty(this.editEmailForm);
    this.profileConfirmModalService.$checkDirty.subscribe((value) => {
      this.confirmModal = value;
    });

    if (this.confirmModal === false) {
      this.changeProfileEmailService.clearEmail();
      this.changeProfileEmailService.clearProcess();
      if (this.previousURL === '/billing/paperless') {
        this.router.navigate(['/billing/paperless']);
      } else {
        this.router.navigate(['/profile']);
      }
    }
  }

  ngOnInit() {
    this.currentEmail =
      this.storageServiceObservablesService.getUserFromStorage();
    this.editEmailForm = this.ipt.toFormGroup(this.inputs);
    this.changeProfileEmailService.$email.subscribe((newEmail) => {
      this.editEmailValue(newEmail);
    });
    this.previousURL = this.paperlessService.getCurrentRoute();
  }
}
